import "../sass/app.scss";

import CarouselHeroCaption from "./modules/CarouselHeroCaption";
import CarouselHeroImages from "./modules/CarouselHeroImages";
import TransparentHeader from "./modules/TransparentHeader";
import ThreeSlidesTextCarousel from "./modules/ThreeSlidesTextCarousel";
import Animations from "./modules/Animations";
import CarouselThreeImages from "./modules/CarouselThreeImages";
import CarouselImageFullWidth from "./modules/CarouselImageFullWidth";
import CarouselTestimonials from "./modules/CarouselTestimonials";
import CarouselOnePictureMargins from "./modules/CarouselOnePictureMargins";

// const threeSlideCarousel = new ThreeSlideCarousel();
const carouselHeroCaption = new CarouselHeroCaption();
const carouselHeroImages = new CarouselHeroImages();
const transparentHeader = new TransparentHeader();
const threeSlidesTextCarosel = new ThreeSlidesTextCarousel();
const animations = new Animations();
const carouselThreeImages = new CarouselThreeImages();
const carouselImageFullWidth = new CarouselImageFullWidth();
const carouselTestimonials = new CarouselTestimonials();
const carouselOnePictureMargins = new CarouselOnePictureMargins();
